/**
 * @copyright Copyright (c) Mathieu Vanbeselaëre
 */

// ** File summary ** //
// Golbal animations for the website

// ************** GSAP animation modules (Uncomment required gsap library!) ************** //
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
// *=====================================================================================* //

export const animations = () => {
    let mobile = window.innerWidth <= 768;

    // * fadeUp * //
    let fadeUps = document.querySelectorAll('[data-anim="fadeUp"]');
    if (fadeUps.length > 0) {
        for (let fadeUp of fadeUps) {
            gsap.to(fadeUp, {
                autoAlpha: 1,
                y: 0,
                scrollTrigger: {
                    trigger: fadeUp,
                    start: mobile ? 'top 75%' : 'top center',
                },
            });
        }
    }

    let reveals = document.querySelectorAll('[data-anim="reveal"]');
    if (reveals.length > 0) {
        for (let reveal of reveals) {
            gsap.to(reveal, {
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: reveal,
                    start: mobile ? 'top 75%' : 'top center',
                },
            });
        }
    }

    return;
};
